import React from 'react';

const NotFound = () => {
    return (
        <div className = "not_found_container">
            <div>
            Houstan that is an error...page not found!
            </div>
      
        </div>
    );
};

export default NotFound;


// WEBPACK FOOTER //
// ./src/Components/ui/NotFound.jsx